/*子页面布局*/
<template>
  <div class="an_child content">
    <div class="banner">
        <slot name="bannner"></slot>
    </div>
    <!--<div class="bread">
      <slot name="bread"></slot>
    </div>-->
    <div class="child_content d-flex">
      <div class="child_content_left">
        <slot name="c_left"></slot>
      </div>
      <div class="child_content_right flex-auto">
        <slot name="c_right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnChild"
};
</script>

<style lang="stylus">
.an_child 
    .banner
        background #639FCE
    img
        margin 0 auto 
  .bread 
    margin: 0 0 23px;
  .child_content_left 
    width: 282px
  .child_content_right 
    padding: 0 0 0 30px
    &>div
      border 1px solid #d5d5d5
      padding 10px 30px
</style> 